/**
 * Composite an RGBA buffer onto white, returning flat RGB bytes (sRGB).
 *
 * Thin wrapper over `epaper_dithering_core::composite::composite_rgba_on_white` so that
 * JavaScript, Python and Rust all flatten alpha identically. Throws if the buffer length
 * is not a multiple of 4.
 * @param {Uint8Array} rgba
 * @returns {Uint8Array}
 */
export function composite_rgba(rgba) {
    const ptr0 = passArray8ToWasm0(rgba, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.composite_rgba(ptr0, len0);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v2;
}

/**
 * Dither a flat RGB image. Accepts either an idealized `scheme_id` or a measured
 * `palette_bytes`/`accent_idx` pair; `palette_bytes` empty ⇒ use `scheme_id`.
 *
 * Returns a `Uint8Array` of palette indices (one per pixel, length = width × height).
 * @param {Uint8Array} pixels
 * @param {number} width
 * @param {number | null | undefined} scheme_id
 * @param {Uint8Array} palette_bytes
 * @param {number} accent_idx
 * @param {number} mode_id
 * @param {boolean} serpentine
 * @param {number} exposure
 * @param {number} saturation
 * @param {number} shadows
 * @param {number} highlights
 * @param {number | null} [tone]
 * @param {number | null} [gamut]
 * @returns {Uint8Array}
 */
export function dither_image(pixels, width, scheme_id, palette_bytes, accent_idx, mode_id, serpentine, exposure, saturation, shadows, highlights, tone, gamut) {
    const ptr0 = passArray8ToWasm0(pixels, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    const ptr1 = passArray8ToWasm0(palette_bytes, wasm.__wbindgen_malloc);
    const len1 = WASM_VECTOR_LEN;
    const ret = wasm.dither_image(ptr0, len0, width, isLikeNone(scheme_id) ? 0xFFFFFF : scheme_id, ptr1, len1, accent_idx, mode_id, serpentine, exposure, saturation, shadows, highlights, !isLikeNone(tone), isLikeNone(tone) ? 0 : tone, !isLikeNone(gamut), isLikeNone(gamut) ? 0 : gamut);
    if (ret[3]) {
        throw takeFromExternrefTable0(ret[2]);
    }
    var v3 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
    wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    return v3;
}

/**
 * Returns all measured palettes as a JSON string.
 *
 * Format: `[{"id": "SPECTRA_7_3_6COLOR", "colors": [[r,g,b], ...], "color_names": [...], "accent_idx": 3, "scheme_id": 4}, ...]`
 * @returns {string}
 */
export function measured_palettes() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.measured_palettes();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}
export function __wbindgen_cast_0000000000000001(arg0, arg1) {
    // Cast intrinsic for `Ref(String) -> Externref`.
    const ret = getStringFromWasm0(arg0, arg1);
    return ret;
}
export function __wbindgen_init_externref_table() {
    const table = wasm.__wbindgen_externrefs;
    const offset = table.grow(4);
    table.set(0, undefined);
    table.set(offset + 0, undefined);
    table.set(offset + 1, null);
    table.set(offset + 2, true);
    table.set(offset + 3, false);
}
function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

function getStringFromWasm0(ptr, len) {
    return decodeText(ptr >>> 0, len);
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

let WASM_VECTOR_LEN = 0;


let wasm;
export function __wbg_set_wasm(val) {
    wasm = val;
}
